import { render, staticRenderFns } from "./ViewSetting.vue?vue&type=template&id=54d5cd56&"
import script from "./ViewSetting.vue?vue&type=script&lang=js&"
export * from "./ViewSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports